/* @flow */

import * as React from 'react';
import type {FieldProps} from 'redux-form';

import {TextField, type Props as TextFieldProps} from '../textfield/textfield';
import {FormField} from '../form';

type OwnProps = {|
    title?: string,
    placeholder?: string,
    helperText?: string,
    multiline?: boolean,
    isRequired?: boolean,
    focusOnMount?: boolean,
    noMargin?: boolean,
    ...$Exact<TextFieldProps>,
|};

type Props = {...$Exact<FieldProps>, ...OwnProps};

export function ReduxFormTextField({
    title,
    helperText,
    isRequired,
    noMargin,
    input,
    meta,
    ...restProps
}: Props) {
    return (
        <FormField
            innerId={input.name}
            label={title}
            helperText={helperText}
            errorMessage={meta.error && meta.submitFailed ? meta.error : null}
            isRequired={isRequired}
            noMargin={noMargin}
        >
            <TextField {...input} {...restProps} />
        </FormField>
    );
}
